@if (form$ | async) {
  @if ((form$ | async)?.loading || (loading$ | async)) {
    <crm-spinner></crm-spinner>
  }

  @if ((loading$ | async) === false) {
    <div class="grid">
      <div class="col-12">
        <p-card>
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium required-field">Название</label>
              <crm-input-text
                [(value)]="dealType.name"
                placeholder="Введите название типа сделки"
                [isError]="$any(errors?.name)"
                [disabled]="!(form$ | async)?.canWrite"
                class="w-full">
              </crm-input-text>
              @if (errors?.name) {
                <small class="p-error">
                  {{ errors.name | join }}
                </small>
              }
            </div>

            <div class="field">
              <label class="font-medium">Компания по-умолчанию</label>
              <crm-company-single-select
                [disabled]="!(form$ | async)?.canWrite"
                [selectedCompany]="$any(dealType.defaultCompany)"
                [showClear]="true"
                appendTo="body"
                (selectedCompanyChange)="dealType.defaultCompany = $any($event)">
              </crm-company-single-select>
            </div>

            <div class="field">
              <label class="font-medium">Номенклатура по-умолчанию</label>
              <crm-nomenclature-multi-select
                [disabled]="!(form$ | async)?.canWrite"
                [nomenclatures]="nomenclatures"
                [showClear]="true"
                [isFloatLabel]="false"
                [groupsDisabled]="!(form$ | async)?.canWrite"
                [selectedNomenclatures]="$any(dealType.defaultNomenclatures)"
                placeholder="Выберите номенклатуру"
                (selectedNomenclaturesChange)="dealType.defaultNomenclatures = $any($event)">
              </crm-nomenclature-multi-select>
            </div>

            <div class="field">
              <label class="font-medium">Шаблон полей</label>
              <crm-eav-entity-type-single-select
                [disabled]="!(form$ | async)?.canWrite"
                [selectedType]="$any(dealType.eavEntityType)"
                placeholder="Выберите шаблон полей"
                (selectedTypeChange)="dealType.eavEntityType = $any($event)">
              </crm-eav-entity-type-single-select>
            </div>
          </div>
        </p-card>

        <p-card
          header="Участники"
          styleClass="mt-3">
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium">Ответственный</label>
              <crm-user-single-select
                [disabled]="!(form$ | async)?.canWrite"
                [selectedUser]="$any(dealType.responsible)"
                [showClear]="true"
                appendTo="body"
                placeholder="Выберите ответственного"
                (selectedUserChange)="dealType.responsible = $any($event)">
              </crm-user-single-select>
            </div>

            <div class="field">
              <label class="font-medium">Пользователи</label>
              <crm-user-multi-select
                [disabled]="!(form$ | async)?.canWrite"
                [selectedUsers]="$any(dealType.auditorUsers)"
                [showClear]="true"
                [isFloatLabel]="false"
                (selectedUsersChange)="dealType.auditorUsers = $any($event)">
              </crm-user-multi-select>
            </div>

            <div class="field">
              <label class="font-medium">Группы</label>
              <crm-user-group-multi-select
                [disabled]="!(form$ | async)?.canWrite"
                [selectedUserGroups]="$any(dealType.auditorGroups)"
                [showClear]="true"
                [isFloatLabel]="false"
                (selectedUserGroupsChange)="dealType.auditorGroups = $any($event)">
              </crm-user-group-multi-select>
            </div>
          </div>
        </p-card>
      </div>
    </div>

    @if ((form$ | async)?.canWrite) {
      <div class="mt-3">
        <div class="flex flex-wrap justify-content-between">
          <crm-button
            label="Сохранить"
            styleClass="p-button-success"
            (onClick)="saveDealType()">
          </crm-button>

          @if ((form$ | async)?.isShowDelete && dealType.id && !dealType.deleted && !dealType.isRentDefault) {
            <crm-button
              label="Удалить"
              styleClass="p-button-danger p-button-text"
              (onClick)="deleteDealType()">
            </crm-button>
          }
        </div>
      </div>
    }
  }
}
